// import rootCommonRoutes from '../../../common/routes';

export const commonRoutes = [
  // ...rootCommonRoutes
]